import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "./style.module.css";
/*
 * Process Button Component
 */
const ProcessButton = ({ label, subLabel, onClick, selected, extraClassName }) => (_jsxs("button", { className: `${styles.process_button} ${selected ? styles.process_button__selected : ""} ${extraClassName || ""}`, type: "button", onClick: onClick, "data-profileclick": label, children: [_jsx("span", { className: styles.process_button_label, children: _jsx("b", { children: label }) }), subLabel && _jsx("span", { className: styles.process_button_sublabel, children: subLabel })] }));
export default ProcessButton;
